import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { Buffer } from 'buffer';
import exifr from 'exifr';

import { removeOrigin } from '../../../../helpers/urls';
import style from './style.module.scss';

const displayMessage = (text) => <tr key="error" className="text-center"><td>{text}</td></tr>;

const Exif = ({ url, isPanelOpen }) => {
  const [fetchedUrl, setFetchedUrl] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [imageSize, setImageSize] = useState();
  const [list, setList] = useState([]);

  const getImageData = async () => {
    try {
      setLoading(true);
      setFetchedUrl(url);
      // Use rawURI for EXIF data (enhanced images may have stripped EXIF)
      const response = await fetch(removeOrigin(url));
      const buffer = Buffer.from(await response.arrayBuffer());

      const exifInfo = await exifr.parse(buffer).catch(() => ({}));

      setData({
        FileSize: `${Math.fround(Buffer.byteLength(buffer) / (1000)).toString().slice(0, 6)} kB`,
        ImageSize: imageSize,
        ...exifInfo,
      });
    } catch (e) {
      console.error(e);
      setList([displayMessage('Sorry Something Went Wrong')]);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isPanelOpen && fetchedUrl !== url) {
      getImageData();
    }
  }, [url, isPanelOpen]);

  useEffect(() => {
    const img = document.getElementById('lightboxImage');
    const onLoad = () => setImageSize(`${img.naturalWidth} X ${img.naturalHeight}`);

    if (img) {
      if (img.complete && isPanelOpen) {
        onLoad();
      } else if (isPanelOpen) {
        img.addEventListener('load', onLoad);
      } else {
        img.removeEventListener('load', onLoad);
      }
    }

    return () => {
      if (img) {
        img.removeEventListener('load', onLoad);
      }
    };
  }, [fetchedUrl, isPanelOpen]);

  useEffect(() => {
    if (data) {
      const entries = [];
      Object.entries({ ...data, ImageSize: imageSize }).forEach(([key, value]) => {
        if (key === 'ImageDescription' && typeof value === 'string' && value.includes(';')) {
          // Parse ImageDescription with semicolon-separated key-value pairs
          value.split(';').forEach((item) => {
            const trimmedItem = item.trim();
            if (!trimmedItem) return;
            const colonIndex = trimmedItem.indexOf(':');
            if (colonIndex > 0) {
              const itemKey = trimmedItem.substring(0, colonIndex).trim();
              const itemValue = trimmedItem.substring(colonIndex + 1).trim();
              entries.push(
                <tr key={`ImageDescription-${itemKey}`}>
                  <td>{itemKey}</td>
                  <td>{itemValue}</td>
                </tr>,
              );
            } else {
              entries.push(
                <tr key={`ImageDescription-${trimmedItem}`}>
                  <td colSpan={2}>{trimmedItem}</td>
                </tr>,
              );
            }
          });
        } else {
          entries.push(
            <tr key={key}>
              <td>{key}</td>
              <td>{key === 'ExposureTime' ? `1/${1 / value} sec` : value}</td>
            </tr>,
          );
        }
      });
      setList(entries.length ? entries : [displayMessage('No data to display')]);
      setLoading(false);
    }
  }, [data, imageSize]);

  if (loading) {
    return (
      <div className="text-center">
        <Spinner as="span" animation="border" role="status" aria-hidden="true" />
      </div>
    );
  }

  return (
    <table className={style.exif}>
      <tbody>
        {list}
      </tbody>
    </table>
  );
};

export default connect(
  ({
    lightbox: {
      info: {
        exifData: {
          open,
        },
      },
      snapshot: {
        data: { rawURI },
      },
    },
  }) => ({
    isPanelOpen: open,
    url: rawURI,
  }),
)(Exif);
